import type { CategoryKey } from '@/types';

export const categoryLabels: Record<string, Record<CategoryKey, string>> = {
  en: {
    '22': 'Finance',
    '25': 'News',
    '17': 'Sports',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Soccer',
    '35': 'Trump',
    '36': 'Ukraine War',
    '37': 'Israel Arab',
    '38': 'Lionel Messi',
    '100': 'City News',
    city: 'News',
    buy_sell: 'Buy & Sell',
    dating: 'Dating',
    events: 'Events',
    jobs: 'Jobs',
    housing: 'Housing',
    cars: 'Cars',
  },
  fr: {
    '22': 'Finance',
    '25': 'Actualités',
    '17': 'Sports',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Football',
    '35': 'Trump',
    '36': 'Guerre en Ukraine',
    '37': 'Israël et le monde arabe',
    '38': 'Lionel Messi',
    '100': 'Actualités de la ville',
    city: 'Actualités',
    buy_sell: 'Acheter & Vendre',
    dating: 'Rencontres',
    events: 'Événements',
    jobs: 'Emplois',
    housing: 'Logement',
    cars: 'Voitures',
  },
  de: {
    '22': 'Finanzen',
    '25': 'Nachrichten',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fußball',
    '35': 'Trump',
    '36': 'Ukraine-Krieg',
    '37': 'Israel und Arabische Welt',
    '38': 'Lionel Messi',
    '100': 'Stadt Nachrichten',
    city: 'Nachrichten',
    buy_sell: 'Kaufen & Verkaufen',
    dating: 'Dating',
    events: 'Veranstaltungen',
    jobs: 'Jobs',
    housing: 'Wohnungen',
    cars: 'Autos',
  },
  es: {
    '22': 'Finanzas',
    '25': 'Noticias',
    '17': 'Deportes',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fútbol',
    '35': 'Trump',
    '36': 'Guerra de Ucrania',
    '37': 'Israel y el Mundo Árabe',
    '38': 'Lionel Messi',
    '100': 'Noticias de la Ciudad',
    city: 'Noticias',
    buy_sell: 'Compra y Venta',
    dating: 'Citas',
    events: 'Eventos',
    jobs: 'Empleos',
    housing: 'Vivienda',
    cars: 'Autos',
  },
  it: {
    '22': 'Finanza',
    '25': 'Notizie',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Calcio',
    '35': 'Trump',
    '36': 'Guerra in Ucraina',
    '37': 'Israele e mondo arabo',
    '38': 'Lionel Messi',
    '100': 'Notizie della città',
    city: 'Notizie',
    buy_sell: 'Compra & Vendi',
    dating: 'Incontri',
    events: 'Eventi',
    jobs: 'Lavoro',
    housing: 'Alloggi',
    cars: 'Auto',
  },
  nl: {
    '22': 'Financiën',
    '25': 'Nieuws',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Voetbal',
    '35': 'Trump',
    '36': 'Oorlog in Oekraïne',
    '37': 'Israël en Arabische wereld',
    '38': 'Lionel Messi',
    '100': 'Stadsnieuws',
    city: 'Nieuws',
    buy_sell: 'Kopen & Verkopen',
    dating: 'Dating',
    events: 'Evenementen',
    jobs: 'Banen',
    housing: 'Huisvesting',
    cars: "Auto's",
  },
  pl: {
    '22': 'Finanse',
    '25': 'Wiadomości',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Piłka nożna',
    '35': 'Trump',
    '36': 'Wojna na Ukrainie',
    '37': 'Izrael i świat arabski',
    '38': 'Lionel Messi',
    '100': 'Wiadomości miejskie',
    city: 'Wiadomości',
    buy_sell: 'Kup & Sprzedaj',
    dating: 'Randki',
    events: 'Wydarzenia',
    jobs: 'Praca',
    housing: 'Mieszkania',
    cars: 'Samochody',
  },
  pt: {
    '22': 'Finanças',
    '25': 'Notícias',
    '17': 'Esportes',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Futebol',
    '35': 'Trump',
    '36': 'Guerra na Ucrânia',
    '37': 'Israel e Mundo Árabe',
    '38': 'Lionel Messi',
    '100': 'Notícias da Cidade',
    city: 'Notícias',
    buy_sell: 'Comprar & Vender',
    dating: 'Namoro',
    events: 'Eventos',
    jobs: 'Empregos',
    housing: 'Moradia',
    cars: 'Carros',
  },
  el: {
    '22': 'Οικονομία',
    '25': 'Ειδήσεις',
    '17': 'Αθλητικά',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Ποδόσφαιρο',
    '35': 'Trump',
    '36': 'Πόλεμος στην Ουκρανία',
    '37': 'Ισραήλ και Αραβικός κόσμος',
    '38': 'Lionel Messi',
    '100': 'Ειδήσεις πόλης',
    city: 'Ειδήσεις',
    buy_sell: 'Αγορά & Πώληση',
    dating: 'Ραντεβού',
    events: 'Εκδηλώσεις',
    jobs: 'Εργασία',
    housing: 'Στέγαση',
    cars: 'Αυτοκίνητα',
  },
  sv: {
    '22': 'Ekonomi',
    '25': 'Nyheter',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fotboll',
    '35': 'Trump',
    '36': 'Ukrainakriget',
    '37': 'Israel och arabvärlden',
    '38': 'Lionel Messi',
    '100': 'Stadsnyheter',
    city: 'Nyheter',
    buy_sell: 'Köp & Sälj',
    dating: 'Dejting',
    events: 'Evenemang',
    jobs: 'Jobb',
    housing: 'Bostäder',
    cars: 'Bilar',
  },
  da: {
    '22': 'Finans',
    '25': 'Nyheder',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fodbold',
    '35': 'Trump',
    '36': 'Ukrainekrig',
    '37': 'Israel og Arabiske Verden',
    '38': 'Lionel Messi',
    '100': 'By Nyheder',
    city: 'Nyheder',
    buy_sell: 'Køb & Sælg',
    dating: 'Dating',
    events: 'Begivenheder',
    jobs: 'Job',
    housing: 'Boliger',
    cars: 'Biler',
  },
  fi: {
    '22': 'Rahoitus',
    '25': 'Uutiset',
    '17': 'Urheilu',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Jalkapallo',
    '35': 'Trump',
    '36': 'Ukrainan sota',
    '37': 'Israel ja arabimaailma',
    '38': 'Lionel Messi',
    '100': 'Kaupunkisuomen uutiset',
    city: 'Uutiset',
    buy_sell: 'Osta & Myy',
    dating: 'Treffit',
    events: 'Tapahtumat',
    jobs: 'Työt',
    housing: 'Asuminen',
    cars: 'Autot',
  },
  no: {
    '22': 'Finans',
    '25': 'Nyheter',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fotball',
    '35': 'Trump',
    '36': 'Ukrainakrigen',
    '37': 'Israel og arabiske verden',
    '38': 'Lionel Messi',
    '100': 'Bynyheter',
    city: 'Nyheter',
    buy_sell: 'Kjøp & Selg',
    dating: 'Dating',
    events: 'Arrangementer',
    jobs: 'Jobber',
    housing: 'Bolig',
    cars: 'Biler',
  },
  cs: {
    '22': 'Finanční',
    '25': 'Zprávy',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fotbal',
    '35': 'Trump',
    '36': 'Válka na Ukrajině',
    '37': 'Izrael a Arabský svět',
    '38': 'Lionel Messi',
    '100': 'Městské zprávy',
    city: 'Zprávy',
    buy_sell: 'Koupit & Prodat',
    dating: 'Seznamování',
    events: 'Události',
    jobs: 'Práce',
    housing: 'Bydlení',
    cars: 'Auta',
  },
  hu: {
    '22': 'Pénzügy',
    '25': 'Hírek',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Labdarúgás',
    '35': 'Trump',
    '36': 'Ukrajna háború',
    '37': 'Izrael és az Arab világ',
    '38': 'Lionel Messi',
    '100': 'Városi hírek',
    city: 'Hírek',
    buy_sell: 'Vásárlás & Eladás',
    dating: 'Társkeresés',
    events: 'Események',
    jobs: 'Állások',
    housing: 'Lakás',
    cars: 'Autók',
  },
  ro: {
    '22': 'Finanțe',
    '25': 'Știri',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Fotbal',
    '35': 'Trump',
    '36': 'Război în Ucraina',
    '37': 'Israel și lumea arabă',
    '38': 'Lionel Messi',
    '100': 'Știri oraș',
    city: 'Știri',
    buy_sell: 'Cumpără & Vinde',
    dating: 'Întâlniri',
    events: 'Evenimente',
    jobs: 'Locuri de muncă',
    housing: 'Locuințe',
    cars: 'Mașini',
  },
  bg: {
    '22': 'Финанси',
    '25': 'Новини',
    '17': 'Спорт',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Футбол',
    '35': 'Тръмп',
    '36': 'Войната в Украйна',
    '37': 'Израел и арабският свят',
    '38': 'Лионел Меси',
    '100': 'Градски новини',
    city: 'Новини',
    buy_sell: 'Купуване & Продажба',
    dating: 'Запознанства',
    events: 'Събития',
    jobs: 'Работа',
    housing: 'Жилища',
    cars: 'Коли',
  },
  hr: {
    '22': 'Financije',
    '25': 'Vijesti',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Nogomet',
    '35': 'Trump',
    '36': 'Rat u Ukrajini',
    '37': 'Izrael i Arapski svijet',
    '38': 'Lionel Messi',
    '100': 'Vijesti grada',
    city: 'Vijesti',
    buy_sell: 'Kupiti & Prodati',
    dating: 'Upoznavanje',
    events: 'Događaji',
    jobs: 'Poslovi',
    housing: 'Stanovanje',
    cars: 'Automobili',
  },
  lt: {
    '22': 'Finansai',
    '25': 'Naujienos',
    '17': 'Sportas',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Futbolas',
    '35': 'Trump',
    '36': 'Ukrainos karas',
    '37': 'Izraelis ir Arabų pasaulis',
    '38': 'Lionel Messi',
    '100': 'Miestų naujienos',
    city: 'Naujienos',
    buy_sell: 'Pirkti & Parduoti',
    dating: 'Pažintys',
    events: 'Renginiai',
    jobs: 'Darbas',
    housing: 'Būstas',
    cars: 'Automobiliai',
  },
  lv: {
    '22': 'Finanses',
    '25': 'Ziņas',
    '17': 'Sports',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Futbols',
    '35': 'Trump',
    '36': 'Ukrainas karš',
    '37': 'Izraēla un Arābu pasaule',
    '38': 'Lionel Messi',
    '100': 'Pilsētas ziņas',
    city: 'Ziņas',
    buy_sell: 'Pirkt & Pārdot',
    dating: 'Dienas',
    events: 'Notikumi',
    jobs: 'Darbs',
    housing: 'Mājoklis',
    cars: 'Automašīnas',
  },
  et: {
    '22': 'Rahandus',
    '25': 'Uudised',
    '17': 'Sport',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'Jalgpall',
    '35': 'Trump',
    '36': 'Ukraina sõda',
    '37': 'Iisrael ja Araabimaa',
    '38': 'Lionel Messi',
    '100': 'Linna uudised',
    city: 'Uudised',
    buy_sell: 'Osta & Müü',
    dating: 'Tuttavaks saamine',
    events: 'Üritused',
    jobs: 'Töö',
    housing: 'Elamine',
    cars: 'Autod',
  },
  zhCN: {
    '22': '财经',
    '25': '新闻',
    '17': '体育',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': '足球',
    '35': '特朗普',
    '36': '乌克兰战争',
    '37': '以阿冲突',
    '38': '梅西',
    '100': '城市新闻',
    city: '新闻',
    buy_sell: '买卖',
    dating: '交友',
    events: '活动',
    jobs: '工作',
    housing: '住房',
    cars: '汽车',
  },
  ar: {
    '22': 'المالية',
    '25': 'أخبار',
    '17': 'رياضة',
    '30': 'NBA',
    '31': 'NHL',
    '32': 'NFL',
    '33': 'كرة القدم',
    '35': 'ترامب',
    '36': 'حرب أوكرانيا',
    '37': 'إسرائيل والعرب',
    '38': 'ليونيل ميسي',
    '100': 'أخبار المدينة',
    city: 'أخبار',
    buy_sell: 'بيع وشراء',
    dating: 'مواعدة',
    events: 'فعاليات',
    jobs: 'وظائف',
    housing: 'سكن',
    cars: 'سيارات',
  },
};
